import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const EDIT_PROPERTY_API = `${LOCAL_URL}/property/editProperty`
export const EDIT_SUBDIVISION = `${LOCAL_URL}/property/editSubDivision`
export const DELETE_SUBDIVISION = `${LOCAL_URL}/property/removeSubDivision`
export const DELETE_IMAGE = `${LOCAL_URL}/property/removePropertyImg`
export const DELETE_DOCUMENT = `${LOCAL_URL}/property/removePropertyDoc`
export const EDIT_INVENTORY = `${LOCAL_URL}/property/editPropertyInventory`
export const DELETE_INVENTORY = `${LOCAL_URL}/property/removePropertyInventory`
export const UPDATE_GST_STATUS = `${LOCAL_URL}/property/updateGstStatus`
export const GET_GST_STATUS = `${LOCAL_URL}/property/getGstStatus`
export const GET_PAN_GST = `${LOCAL_URL}/property/getPanGST`
export const UPDATE_PAN_GST = `${LOCAL_URL}/property/udpatePanGST`

const headers = {
  Authorization: API_TOKEN,
  //'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
}

export async function Edit_Propertys(
  property_uuid: string,
  property_type_uuid: string,
  property_title: string,
  carpet_area: string,
  carpet_area_unit_uuid: string,
  address_1: string,
  address_2: string,
  country_id: string,
  province_id: string,
  city: string,
  pin_zip: string,
  current_rent: string,
  sub_unit_available: boolean,
  property_usage_type: string,
  unitdetails: any[]
) {
  return await axios.put(EDIT_PROPERTY_API, {
    property_uuid,
    property_type_uuid,
    property_title,
    carpet_area,
    carpet_area_unit_uuid,
    address_1,
    address_2,
    country_id,
    province_id,
    city,
    pin_zip,
    current_rent,
    sub_unit_available,
    property_usage_type,
    unitdetails,
  })
}

export async function Edit_Property_overview(
  property_uuid: string,
  property_type_uuid: string,
  property_title: string,
  carpet_area: number,
  carpet_area_unit_uuid: string,
  address_1: string,
  address_2: string,
  country_id: number,
  province_id: number,
  city: string,
  pin_zip: string,
  current_rent: number,
  account_kyc_uuid: string,
  sub_unit_available: boolean,
  property_usage_type: number,
  property_furnishing_status: number,
  sub_units: any,
  inventoryDetails: any
) {
  return await axios.post(EDIT_PROPERTY_API, {
    property_uuid,
    property_type_uuid,
    property_title,
    carpet_area,
    carpet_area_unit_uuid,
    address_1,
    address_2,
    country_id,
    province_id,
    city,
    pin_zip,
    current_rent,
    account_kyc_uuid,
    sub_unit_available,
    property_usage_type,
    property_furnishing_status,
    sub_units,
    inventoryDetails,
  })
}

export async function Edit_Subdivision(property_sub_unit_uuid: string,
  property_unit_description: string,
  property_unit_max_tenants: number,
  property_unit_name: string,
  property_unit_rent: string) {
  return await axios.post(EDIT_SUBDIVISION, {
    property_sub_unit_uuid,
    property_unit_description,
    property_unit_max_tenants,
    property_unit_name,
    property_unit_rent
  })
}

export async function Delete_Subdivision(property_sub_unit_uuid: string) {
  return await axios.post(DELETE_SUBDIVISION, { property_sub_unit_uuid })
}

export async function Delete_Image(property_image_uuid: string) {
  return await axios.post(DELETE_IMAGE, { property_image_uuid })
}

export async function Delete_Document(property_document_uuid: string) {
  return await axios.post(DELETE_DOCUMENT, { property_document_uuid })
}

export async function Edit_Inventory(inventory_item_name: string,
  inventory_remarks: string,
  inventory_unit_set_name: string,
  inventory_unit_set_number: number,
  property_inventory_uuid: string) {
  return await axios.post(EDIT_INVENTORY, {
    inventory_item_name,
    inventory_remarks,
    inventory_unit_set_name,
    inventory_unit_set_number,
    property_inventory_uuid
  })
}

export async function Delete_Inventory(property_inventory_uuid: string) {
  return await axios.post(DELETE_INVENTORY, { property_inventory_uuid })
}

export async function Update_Gst_Status(property_uuid: string,
  invoice_gst_applicable: boolean) {
  return await axios.post(UPDATE_GST_STATUS, {
    property_uuid,
    invoice_gst_applicable
  })
}

export async function Get_Gst_Status(property_uuid: string) {
  return await axios.post(GET_GST_STATUS, { property_uuid })
}

export async function Get_PAN_GST(property_uuid: string) {
  return await axios.post(GET_PAN_GST, { property_uuid })
}

export async function Update_PAN_GST(property_uuid: string, pan: string, gstin: string, cin: string) {
  return await axios.post(UPDATE_PAN_GST, { property_uuid, pan, gstin, cin })
}